export type AccountOriginSurface =
  | "web"
  | "telegram"
  | "line"
  | "discord"
  | "teams"
  | "vk"
  | "max"
  | "unknown";

export type AuthOutcome = {
  isNewUser: boolean;
  originSurface: AccountOriginSurface | null;
};

const KNOWN_SURFACES = new Set<AccountOriginSurface>([
  "web",
  "telegram",
  "line",
  "discord",
  "teams",
  "vk",
  "max",
  "unknown",
]);

export function parseAuthOutcome(value: {
  is_new_user?: unknown;
  origin_surface?: unknown;
}): AuthOutcome {
  return {
    isNewUser: value.is_new_user === true,
    originSurface:
      typeof value.origin_surface === "string" &&
      KNOWN_SURFACES.has(value.origin_surface as AccountOriginSurface)
        ? (value.origin_surface as AccountOriginSurface)
        : null,
  };
}

/** Emits attribution without profile fields, host user ids, tokens or codes. */
export async function recordAuthOutcome(
  outcome: AuthOutcome,
  provider: AccountOriginSurface,
  surface: AccountOriginSurface,
): Promise<void> {
  try {
    const { track } = await import("./analytics");
    track(outcome.isNewUser ? "account_created" : "sign_in", { provider, surface });
  } catch {
    // Authentication must remain successful if optional analytics is blocked.
  }
}
